import React from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { i18n } from "app/i18n/i18n";
import SubscriptionsButton from "components/Subscriptions/SubscriptionsButton/SubscriptionsButton";
import { useAutoSubscribePublication } from "lib/hooks/useSubscriptions/useAutoSubscribePublication";
import { ShareButton } from "components/ShareMenu/ShareButton";
import { AdvertCard } from "pages/Ads/Adverts/AdvertCard";
import { features } from "app/features";
import { PublicationDate, Title, Analysts, Tags, Synopsis } from "./PublicationItems";
import ErrorBoundary from "../../lib/ErrorBoundary";
import { NoPublicationsFound } from "../ViewLayout/ViewLayout";
import { FileTypeIcon } from "../TileView/PublicationCardParts";
import aiSumHover from "../PublicationCard/assets/icons/NaiRa_SUM_BUT_HOVER.svg";
import aiSumOn from "../PublicationCard/assets/icons/NaiRa_SUM_BUT_ON.svg";
import { useShowAiSummary } from "../../lib/hooks/useShowAiSummary";
import { auditAiSummaryClick } from "lib/analytics/auditEvents";

import styles from "./ListView.module.scss";

export function ListView({ publications = [] }) {
  const lang = i18n.getLanguage();

  return (
    <ErrorBoundary>
      <ListGroup variant="flush" className="mb-2">
        {publications.map((publication) => {
          const key = publication.id;

          if (!publication.cardType) {
            return <PublicationItem publication={publication} lang={lang} key={key} />;
          }

          if (publication.cardType === "advert") {
            return <AdvertCard key={key} {...publication} />;
          }

          return null;
        })}
        {!publications.length && <NoPublicationsFound />}
      </ListGroup>
    </ErrorBoundary>
  );
}

export function PublicationItem({ publication, lang }) {
  useAutoSubscribePublication(publication);
  const openAISidebar = () => {
    auditAiSummaryClick(publication.id);
    window.dispatchEvent(new CustomEvent('open-naira-chat', { detail: { tab: 1, publicationId: publication.id } }));
  };
  const showAiSummary = useShowAiSummary(publication);

  return (
    <ListGroupItem variant="light" className={`p-1 py-1 lv-publication-item ${styles.listItem}`}>
      <ShareButton publication={publication} />
      <Title {...publication} />
      <Synopsis {...publication} />
      <div style={{ display: "flex", padding: 8, alignItems: "center" }}>
        <PublicationDate {...publication} />
        <Analysts lang={lang} {...publication} />
        <Tags lang={lang} {...publication} />
        <FileTypeIcon {...publication} />
        <div className={styles.actionButtons}>
          {showAiSummary && (
            <button className={styles.aiSummaryBtn} onClick={() => openAISidebar()}>
              <img src={aiSumHover} alt="AI Summary" className={styles.btnIconHover} />
              <img src={aiSumOn} alt="AI Summary" className={styles.btnIconOn} />
            </button>
          )}
          {features.subscriptionButton && (
            <SubscriptionsButton publication={publication} customClass={styles.subscriptionsButton} />
          )}
        </div>
      </div>
    </ListGroupItem>
  );
}
